import { useRef } from "react";
import styles from "./style.module.scss";
import PlusIcon from "images/i-plus.svg";
import MinusIcon from "images/i-minus.svg";
import { marked } from "marked";

const Collapsible = ({ title, content, isOpen, onToggle }) => {
  const contentRef = useRef(null);

  return (
    <div className={styles.collapsible}>
      <div
        className={styles.header}
        onClick={onToggle}
        role="button"
        aria-expanded={isOpen}
      >
        <img
          src={isOpen ? MinusIcon : PlusIcon}
          alt={isOpen ? "-" : "+"}
          className={styles.icon}
        />
        <span>{title}</span>
      </div>
      <div
        ref={contentRef}
        className={`${styles.contentWrapper} ${isOpen ? styles.open : ""}`}
        style={{
          maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : "0",
        }}
      >
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: marked.parse(content) }}
        />
      </div>
    </div>
  );
};

export default Collapsible;
